exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cap-timepicker-v2 .ant-time-picker-input{height:40px;padding:6px 11px}.cap-timepicker-v2 .ant-time-picker-clock-icon{color:#091e42}\n", ""]);

// exports
